import { jsx as _jsx } from "react/jsx-runtime";
import { isSameDay } from 'date-fns';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { BottomLeft, Popup } from '../../utils/popups';
import { Calendar } from '../Calendar';
import { AbstractPopup, } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
export function CalendarPopup({ date, onDateChange, resolve, ...props }) {
    const [previousDate, setPreviousDate] = useState(date);
    useEffect(() => {
        setPreviousDate(date);
    }, [date]);
    return (_jsx(CalendarPopupRoot, { ...props, translateFn: BottomLeft, children: _jsx(Calendar, { value: date, onChange: (value) => {
                if (isSameDay(previousDate, value)) {
                    resolve();
                    return;
                }
                setPreviousDate(value);
                onDateChange?.(value);
            } }) }));
}
const calendarPopup = Popup.create(CalendarPopup);
const CalendarPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.AnchoredBottomLeft};
    --Popup_BackgroundOpacity: 0.2;
    --Popup_BorderRadius: 0.75rem;
    --Popup_Padding: 0;
    --Popup_BoundingBoxPadding: 0.5rem;
    --Popup_Width: auto;
`;
export function showCalendar(date, options = {}) {
    (async () => {
        options.onBeforeOpen?.();
        try {
            await calendarPopup.pop({
                date,
                onDateChange: options.onDateChange,
                anchorRef: options.anchorRef,
                controllerRef: options.controllerRef,
            });
        }
        catch (_ignored) {
            // Do nothing.
        }
        finally {
            options.onAfterClose?.();
        }
    })();
}
